ACC.profile = {
  veryWeakText: $('#veryWeakText').val(),
  weakText: $('#weakText').val(),
  fairText: $('#fairText').val(),
  veryStrongText: $('#veryStrongText').val(),
  warningClass: 'ph-text-warning',
  entrySuccessClass: 'ph-passwordentrysuccess',
  dangerClass: 'ph-text-danger',
  checkmarkIconClass: 'ph-icon-checkmark',
  crossIconClass: 'ph-icon-cross',
  borderClass: 'ph-redoptionborder',
  successClass: 'ph-text-success',
  criteriaColorRed: 'ph-passwordpopup__colorred',
  liTag: 'li',

  checkAlphabets: function(strength, password) {
    var strengthNew = strength;

    if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) {
      strengthNew = strengthNew + 1;

      $('.ph-low-upper-case i').removeClass(ACC.profile.crossIconClass).addClass(ACC.profile.checkmarkIconClass);
      $('.ph-low-upper-case').closest(ACC.profile.liTag).removeClass(ACC.profile.criteriaColorRed);
    } else {
      $('.ph-low-upper-case i').addClass(ACC.profile.crossIconClass).removeClass(ACC.profile.checkmarkIconClass);
      $('.ph-low-upper-case').closest(ACC.profile.liTag).addClass(ACC.profile.criteriaColorRed);
    }

    return strengthNew;
  },

  checkNumbers: function(strength, password) {
    var strengthNew = strength;

    if (password.match(/(\d)/)) {
      strengthNew = strengthNew + 1;

      $('.ph-one-number i').removeClass(ACC.profile.crossIconClass).addClass(ACC.profile.checkmarkIconClass);
      $('.ph-one-number').closest(ACC.profile.liTag).removeClass(ACC.profile.criteriaColorRed);
    } else {
      $('.ph-one-number i').addClass(ACC.profile.crossIconClass).removeClass(ACC.profile.checkmarkIconClass);
      $('.ph-one-number').closest(ACC.profile.liTag).addClass(ACC.profile.criteriaColorRed);
    }

    return strengthNew;
  },

  checkSpecialChars: function(strength, password) {
    var strengthNew = strength;

    if (password.match(/[%&@$^]/) && !password.match(/[`!#*()_+\-=[\]{};':"\\|,.<>/?~]/) && !password.match(/[\s]/)) {
      strengthNew = strengthNew + 1;

      $('.ph-one-special-char i').removeClass(ACC.profile.crossIconClass).addClass(ACC.profile.checkmarkIconClass);
      $('.ph-one-special-char').closest(ACC.profile.liTag).removeClass(ACC.profile.criteriaColorRed);
    } else {
      $('.ph-one-special-char i').addClass(ACC.profile.crossIconClass).removeClass(ACC.profile.checkmarkIconClass);
      $('.ph-one-special-char').closest(ACC.profile.liTag).addClass(ACC.profile.criteriaColorRed);
    }

    return strengthNew;
  },

  checkLength: function(strength, password) {
    var strengthNew = strength;

    if (password.length > 7) {
      strengthNew = strengthNew + 1;

      $('.ph-eight-character i').removeClass(ACC.profile.crossIconClass).addClass(ACC.profile.checkmarkIconClass);
      $('.ph-eight-character').closest(ACC.profile.liTag).removeClass(ACC.profile.criteriaColorRed);
    } else {
      $('.ph-eight-character i').addClass(ACC.profile.crossIconClass).removeClass(ACC.profile.checkmarkIconClass);
      $('.ph-eight-character').closest(ACC.profile.liTag).addClass(ACC.profile.criteriaColorRed);
    }

    return strengthNew;
  },

  checkSame: function(strength, newPassword, checkNewPassword) {
    var strengthNew = strength;

    if ($(newPassword).val() === $(checkNewPassword).val() && $(newPassword).val() !== '') {
      strengthNew = strengthNew + 1;

      $('.ph-password-matches i').removeClass(ACC.profile.crossIconClass).addClass(ACC.profile.checkmarkIconClass);
      $('.ph-password-matches').closest(ACC.profile.liTag).removeClass(ACC.profile.criteriaColorRed);
    } else {
      $('.ph-password-matches i').addClass(ACC.profile.crossIconClass).removeClass(ACC.profile.checkmarkIconClass);
      $('#password-strength5').css('width', '0%');
      $('.ph-password-matches').closest(ACC.profile.liTag).addClass(ACC.profile.criteriaColorRed);
    }

    return strengthNew;
  },

  checkEmptyStrength: function(newPassword, checkNewPassword) {
    $('#result').removeClass(ACC.profile.dangerClass).text('');
    $('#password-strength1').css('width', '0%');
    $('#password-strength2').css('width', '0%');
    $('#password-strength3').css('width', '0%');
    $('#password-strength4').css('width', '0%');
    $('#password-strength5').css('width', '0%');
    $(checkNewPassword).parents().eq(2).find('.' + ACC.profile.entrySuccessClass).addClass('hidden');
    $(newPassword).parent().removeClass(ACC.profile.borderClass);
    $(newPassword).parents().eq(2).find('.' + ACC.profile.entrySuccessClass).addClass('hidden');

    return false;
  },

  checkStrengthLessThanTwo: function(newPassword, checkNewPassword) {
    $('#result').removeClass().addClass('ph-setpassword-result');
    $('#password-strength1').addClass('ph-password_progress__bar--danger ');
    $('#result').addClass(ACC.profile.dangerClass).text(ACC.profile.veryWeakText);
    $('#password-strength1').css('width', '100%');
    $('#password-strength2').css('width', '0%');
    $('#password-strength3').css('width', '0%');
    $('#password-strength4').css('width', '0%');
    $('#password-strength5').css('width', '0%');
    $(newPassword).parent().addClass(ACC.profile.borderClass);
    $(checkNewPassword).parents().eq(2).find('.' + ACC.profile.entrySuccessClass).addClass('hidden');

    return false;
  },

  checkStrengthTwo: function(newPassword, checkNewPassword) {
    $('#password-strength').removeClass('ph-password_progress__bar--danger');
    $('#password-strength2').addClass('ph-password_progress__bar--warning');
    $('#result').addClass(ACC.profile.dangerClass).removeClass(ACC.profile.warningClass).removeClass(ACC.profile.successClass).text(ACC.profile.weakText);
    $('#password-strength2').css('width', '100%');
    $('#password-strength3').css('width', '0%');
    $('#password-strength4').css('width', '0%');
    $('#password-strength5').css('width', '0%');
    $(newPassword).parent().addClass(ACC.profile.borderClass);
    $(checkNewPassword).parents().eq(2).find('.' + ACC.profile.entrySuccessClass).addClass('hidden');

    return false;
  },

  checkStrengthThree: function(newPassword, checkNewPassword) {
    $('#password-strength').removeClass('ph-password_progress__bar--danger');
    $('#password-strength3').addClass('ph-password_progress__bar--warning');
    $('#result').addClass(ACC.profile.warningClass).removeClass('ph-text-danger').removeClass(ACC.profile.successClass).text(ACC.profile.fairText);
    $('#password-strength2').css('width', '100%');
    $('#password-strength3').css('width', '100%');
    $('#password-strength4').css('width', '0%');
    $('#password-strength5').css('width', '0%');
    $(checkNewPassword).parents().eq(2).find('.' + ACC.profile.entrySuccessClass).addClass('hidden');
    $(newPassword).parent().addClass(ACC.profile.borderClass);
    $(newPassword).parents().eq(2).find('.' + ACC.profile.entrySuccessClass).addClass('hidden');

    return false;
  },

  checkStrengthFour: function(newPassword, checkNewPassword) {
    $('#result').removeClass().addClass('ph-setpassword-result');
    $('#password-strength').removeClass('ph-password_progress__bar--warning');
    $('#password-strength4').addClass('ph-password_progress__bar--success');
    $('#result').addClass(ACC.profile.successClass).removeClass(ACC.profile.warningClass).text(ACC.profile.veryStrongText);
    $('#password-strength3').css('width', '100%');
    $('#password-strength4').css('width', '100%');
    $('#password-strength5').css('width', '100%');
    $(newPassword).parent().removeClass(ACC.profile.borderClass);
    $(newPassword).parents().eq(2).find('.' + ACC.profile.entrySuccessClass).removeClass('hidden');
    $(checkNewPassword).parents().eq(2).find('.' + ACC.profile.entrySuccessClass).addClass('hidden');

    return false;
  },

  checkStrengthFive: function(newPassword, checkNewPassword) {
    $('#result').removeClass().addClass('ph-setpassword-result');
    $('#password-strength').removeClass('ph-password_progress__bar--warning');
    $('#password-strength5').addClass('ph-password_progress__bar--success');
    $('#result').addClass(ACC.profile.successClass).removeClass(ACC.profile.warningClass).text(ACC.profile.veryStrongText);
    $('#password-strength4').css('width', '100%');
    $('#password-strength5').css('width', '100%');
    $(newPassword).parent().removeClass(ACC.profile.borderClass);
    $(newPassword).parents().eq(2).find('.' + ACC.profile.entrySuccessClass).removeClass('hidden');
    $(checkNewPassword).parents().eq(2).find('.' + ACC.profile.entrySuccessClass).removeClass('hidden');

    return 'Strong';
  },

  passwordValidation: function(password, newPassword, checkNewPassword) {
    var strength = 0;

    strength = ACC.profile.checkAlphabets(strength, password);
    strength = ACC.profile.checkNumbers(strength, password);
    strength = ACC.profile.checkSpecialChars(strength, password);
    strength = ACC.profile.checkLength(strength, password);
    strength = ACC.profile.checkSame(strength, newPassword, checkNewPassword);

    if (strength === 0 && password === '') {
      return ACC.profile.checkEmptyStrength(newPassword, checkNewPassword);
    } else if (strength < 2) {
      return ACC.profile.checkStrengthLessThanTwo(newPassword, checkNewPassword);
    } else if (strength === 2) {
      return ACC.profile.checkStrengthTwo(newPassword, checkNewPassword);
    } else if (strength === 3) {
      return ACC.profile.checkStrengthThree(newPassword, checkNewPassword);
    } else if (strength === 4) {
      return ACC.profile.checkStrengthFour(newPassword, checkNewPassword);
    } else if (strength === 5) {
      return ACC.profile.checkStrengthFive(newPassword, checkNewPassword);
    }

    return false;
  },

  checkCurrentNewPassword: function(currentPassword, passwordVal) {
    if (currentPassword === passwordVal && currentPassword !== '') {
      $('.ph-current-password-same').addClass('ph-show');
    } else {
      $('.ph-current-password-same').removeClass('ph-show');
    }
  },

  changePassword: function() {
    var profileCurrentPasswordClass = '#profile\\.checkNewPassword',
        profileOldPasswordClass = '#profile\\.currentPassword',
        profileNewPasswordClass = '#profile-newPassword';

    $('#profile-newPassword, #profile\\.checkNewPassword').keyup(function() {
      var passwordVal = $(profileNewPasswordClass).val(),
          currentPassword = $(profileOldPasswordClass).val();

      if (ACC.profile.passwordValidation(passwordVal, profileNewPasswordClass, profileCurrentPasswordClass) === false) {
        $('#update-password').attr('disabled', true);

        ACC.profile.checkCurrentNewPassword(currentPassword, passwordVal);
      } else {
        $('#update-password').attr('disabled', false);
      }
    });

    $(profileOldPasswordClass).keyup(function() {
      var passwordVal = $(profileNewPasswordClass).val(),
          currentPassword = $(profileOldPasswordClass).val();

      if (currentPassword === '') {
        if ($(profileOldPasswordClass).parents().eq(3).find('.ph-form_field_error').length > 0) {
          $(profileOldPasswordClass).parents().eq(3).find('.' + ACC.profile.entrySuccessClass).addClass('hidden');
        } else {
          $(profileOldPasswordClass).parents().eq(2).find('.' + ACC.profile.entrySuccessClass).addClass('hidden');
        }
      } else if ($(profileOldPasswordClass).parents().eq(3).find('.ph-form_field_error').length > 0) {
        $(profileOldPasswordClass).parents().eq(3).find('.' + ACC.profile.entrySuccessClass).removeClass('hidden');
        $(profileOldPasswordClass).parents().eq(3).find('.' + ACC.profile.entrySuccessClass).addClass('ph-errorcurrentpassword');
      } else {
        $(profileOldPasswordClass).parents().eq(2).find('.' + ACC.profile.entrySuccessClass).removeClass('hidden');
        $(profileOldPasswordClass).parents().eq(3).find('.' + ACC.profile.entrySuccessClass).removeClass('ph-errorcurrentpassword');
      }

      ACC.profile.checkCurrentNewPassword(currentPassword, passwordVal);
    });
  },

  addAttrDisabled: function(passwordVal, newPassword, checkNewPassword) {
    if (ACC.profile.passwordValidation(passwordVal, newPassword, checkNewPassword) === false) {
      $('#update-password').attr('disabled', true);
    } else {
      $('#update-password').attr('disabled', false);
    }
  },

  updatePassword: function() {
    $('#updatePwd-pwd, #updatePwd\\.checkPwd').keyup(function() {
      var passwordVal = $('#updatePwd-pwd').val();

      ACC.profile.addAttrDisabled(passwordVal, '#updatePwd-pwd', '#updatePwd\\.checkPwd');
    });
  },

  setPassword: function() {
    $('#setPassword-pwd, #setPassword\\.checkPwd').keyup(function() {
      var passwordVal = $('#setPassword-pwd').val();

      ACC.profile.addAttrDisabled(passwordVal, '#setPassword-pwd', '#setPassword\\.checkPwd');
    });
  }
};

$(document).ready(function() {
  if ($('.ph-updatepasswordfield').length > 0) {
    ACC.profile.updatePassword();
  }

  if ($('.ph-setpasswordfield').length > 0) {
    ACC.profile.setPassword();
  }
});

